import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import DentalChart from "../DentalChart";
import CaseDetails from "./components/CaseDetails";
import { getAuthToken } from "../../utils/auth";
import "../../style/dashboard.css";
import "../../style/customresponsivefile.css";
import { ToothData } from "../../Interfaces/ToothData";
import { OrderType } from "../../Interfaces/Types/OrderType";
import ReuploadScan from "./ReuploadScan";
import ReuploadAddScan from "./ReuploadAddScan";
import ReuploadAddScanUnderreview from "./ReuploadAddScanUnderreview";
import SlotScanPending from "./SlotScanPending";
import { toast } from "react-toastify";
import { apiAxios } from "../../utils/apiAxios";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import WarrantyCard from "../CentralHub/Admin/pages/WarrantyCard";
import Swal from "sweetalert2";
import { ApiResponse } from "../../types/ApiResponse";
import { apiClient } from "../../api/apiClient";
import signalRService from "../../services/signalrService";

type Patient = {
  patientID: number,
  age: number,
  patientName: string,
  dentistTag?: string
}

const Dashboard: React.FC = () => {

  type ViewMode =
    | "dashboard"
    | "caseDetails"
    | "reuploadDetails"
    | "addScan"
    | "underReview"
    | "slotScan";

  const notificationSound = useRef(
    new Audio("/Notificationsound/notification.mp3")
  );
  const querySound = useRef < HTMLAudioElement | null > (null);
  useEffect(() => {
    querySound.current = new Audio("/Notificationsound/Query.mp3");
  }, []);

  const addScanSectionRef = useRef < HTMLDivElement > (null);

  const navigate = useNavigate();
  const [selectedPatientRow, setSelectedPatientRow] = useState < number | null > (null);
  const [patientOrders, setPatientOrders] = useState < OrderType[] > ([]);
  const [viewMode, setViewMode] = useState < ViewMode > ("dashboard");
  const [selectedCancelCaseId, setSelectedCancelCaseId] = useState < number | null > (null);
  const { draftId } = useParams < { draftId?: string } > ();
  const [files, setFiles] = useState < any[] > ([]);
  const [selectedPatient, setSelectedPatient] = useState < any | null > (null);
  const [priceSummary, setPriceSummary] = useState < any | null > (null);
  const [selectedClinicId, setSelectedClinicId] = useState < number | null > (null);
  const [draftSlot, setDraftSlot] = useState < { date: string; time: string } | null > (null);
  const [selectedOrder, setSelectedOrder] = useState < OrderType | null > (null);
  const [selectedOrders, setSelectedOrders] = useState < OrderType[] > ([]);
  const [reuploadCaseId, setReuploadCaseId] = useState < number | null > (null);
  const [activeTab, setActiveTab] = useState < "orders" | "patients" > ("orders");
  const [selectedTeeth, setSelectedTeeth] = useState < ToothData[] > ([]);
  const [lastClickedTooth, setLastClickedTooth] = useState < number | null > (null);
  const [orders, setOrders] = useState < OrderType[] > ([]);
  const [Patient, setPatient] = useState < Patient[] > ([]);
  const [loading, setLoading] = useState(false);
  const [deliveryOtp, setDeliveryOtp] = useState < string | null > (null);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [cancelRemarks, setCancelRemarks] = useState("");
  const [cancelLoading, setCancelLoading] = useState(false);
  const [showChatPopup, setShowChatPopup] = useState(false);
  const [selectedChat, setSelectedChat] = useState < number | null > (1);
  const [conversations, setConversations] = useState < Conversation[] > ([]);
  const [selectedConversation, setSelectedConversation] = useState < Conversation | null > (null);
  const [messages, setMessages] = useState < TicketReply[] > ([]);
  const [conversationCount, setConversationCount] = useState(0);
  const [message, setMessage] = useState("");
  const [selectedFile, setSelectedFile] = useState < File | null > (null);
  const [loadingMessages, setLoadingMessages] = useState(false);
  const [expandedMessages, setExpandedMessages] = useState < number[] > ([]);
  const [previewUrl, setPreviewUrl] = useState("");
  const [cancellationReasons, setCancellationReasons] = useState < any[] > ([]);
  const messagesEndRef = useRef < HTMLDivElement | null > (null);
  const STATUS_CONFIG: Record<string, { className: string; bg: string }> = {
    "Need Attention": {
      className: "status-need-attention danger",
      bg: "red",
    },

    "Under Review": {
      className: "status-under-review",
      bg: "#ffcd39",
    },

    "Completed(Design)": {
      className: "status-getting-prepared",
      bg: "#90EE90",
    },

    "Under Review(Design)": {
      className: "status-under-review",
      bg: "#ffcd39",
    },

    "Delay Report (Design)": {
      className: "status-under-review",
      bg: "#b45309",
    },
    "Getting Prepared": {
      className: "status-getting-prepared",
      bg: "#F8F9FB",

    },
    "Re-upload Scan": {
      className: "reupload-scan-btn",
      bg: "#000000",
    },
    "Scan Pending": {
      className: "status-under-review",
      bg: "#0d6efd",
    },
    "Out for Delivery": {
      className: "outfordelivery",
      bg: "",
    },
    "Cancellation Under Review": {
      className: "reupload-scan-btn2",
      bg: "#FF1A1A",

    },

    "Cancelled": {
      className: "reupload-scan-btn2",
      bg: "#FF1A1A",

    },
    "Delivered": {
      className: "delivered-statusbtn",
      bg: "",

    },

  };

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_PATH = process.env.REACT_APP_API_PATH_URL || "";
  useEffect(() => {
    if (draftId) {
      loadDraft(Number(draftId));
      setViewMode("caseDetails");
    }
  }, [draftId]);
  useEffect(() => {
    if (selectedConversation && messages.length > 0) {
      setTimeout(() => {
        messagesEndRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "end",
        });
      }, 100);
    }
  }, [messages, selectedConversation]);
  //------------------------- chat -------------------------------------

  useEffect(() => {
    const init = async () => {
      await signalRService.startConnection("orderChatHub");

      // Global room join
      await signalRService.invoke(
        "orderChatHub",
        "JoinDentistRoom"
      );

      signalRService.on(
        "orderChatHub",
        "ReceiveMessage",
        async (newMessage) => {

          console.log("ReceiveMessage", newMessage);

          setMessages(prev => {
            const exists = prev.some(x => x.id === newMessage.id);
            return exists ? prev : [...prev, newMessage];
          });

          await getConversations();

          if (newMessage.senderType !== "Dentist" && querySound.current) {
            try {
              querySound.current.pause();
              querySound.current.currentTime = 0;
              await querySound.current.play();
            } catch (err) {
              console.error(err);
            }
          }
        }
      );
    };

    init();

    return () => {
      signalRService.off(
        "orderChatHub",
        "ReceiveMessage"
      );
    };
  }, []);

  const getConversations = async () => {

    try {
      const response =
        await apiClient.get < ApiResponse < Conversation[] >> (
          `${API_BASE_URL}/Ticket/GetConversations?senderType=Dentist`
        );

      if (response.isSuccess) {
        const data = response.data ?? [];
        setConversations(response.data ?? []);
        // Sirf unread conversations ka count
        setConversationCount(
          data.filter(chat => chat.unreadCount > 0).length
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const openConversation = async (
    conversation: Conversation
  ) => {
    try {

      if (selectedConversation) {
        await signalRService.invoke(
          "orderChatHub",
          "LeaveOrderRoom",
          {
            orderId: selectedConversation.orderId
          }

        );
      }

      await signalRService.invoke(
        "orderChatHub",
        "JoinOrderRoom",
        {
          orderId: conversation.orderId
        }

      );

      const formData = new FormData();
      formData.append("TicketId", conversation.ticketId.toString());
      formData.append("SenderType", "Dentist");

      setSelectedConversation(
        conversation
      );

      await apiClient.put < ApiResponse < any >> (
        `${API_BASE_URL}/Ticket/MarkAsSeen`, formData);

      const response =
        await apiClient.get < ApiResponse < TicketReply[] >> (
          `${API_BASE_URL}/Ticket/GetMessages/${conversation.orderId}`
        );

      if (response.isSuccess) {
        setMessages(
          response.data ?? []
        );
      }

      await getConversations();

    } catch (error) {
      console.error(error);
    }
  };
  const sendMessage = async () => {
    if (!selectedConversation) return;

    if (
      !message.trim() &&
      !selectedFile
    ) {
      return;
    }

    try {
      const formData = new FormData();

      formData.append(
        "orderId",
        selectedConversation.orderId
      );

      formData.append(
        "message",
        message
      );

      formData.append(
        "senderType",
        "Dentist"
      );

      if (selectedFile) {
        formData.append(
          "file",
          selectedFile
        );
      }

      const response =
        await apiClient.post < ApiResponse < any >> (
          `${API_BASE_URL}/Ticket/SendMessage`,
          formData
        );

      if (response.isSuccess) {
        setMessage("");
        setSelectedFile(null);
        setPreviewUrl("");

        // await openConversation(
        //   selectedConversation
        // );

        // await getConversations();
      }
    } catch (error) {
      console.error(error);
    }
  };
  const toggleMessage = (id: number) => {
    setExpandedMessages((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  //------------------------- chat -------------------------------------
  useEffect(() => {
    if (viewMode === "addScan") {
      // DOM render hone ka wait karo, phir wahi section pe scroll rok do
      requestAnimationFrame(() => {
        setTimeout(() => {
          addScanSectionRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 50);
      });
    }
  }, [viewMode, reuploadCaseId]);
  const loadDraft = async (id: number) => {
    try {
      const res = await apiAxios.get(`${API_BASE_URL}/Dentist/get-draft/${id}`);
      const draft = res.data;

      if (!draft) return;

      // files
      if (draft.files) {
        setFiles(draft.files);
      }

      // parse orderData
      if (draft.orderData) {
        const parsedData = JSON.parse(draft.orderData);

        if (parsedData.selectedTeeth) {
          setSelectedTeeth(parsedData.selectedTeeth);
        }

        if (parsedData.selectedPatient) {
          setSelectedPatient(parsedData.selectedPatient);
        }

        if (parsedData.priceSummary) {
          setPriceSummary(parsedData.priceSummary);
        }

        // Slot Booking draft: restore date & time
        if (parsedData.serviceType === "slot") {
          setDraftSlot({
            date: parsedData.slotDate || "",
            time: parsedData.slotTime || "",
          });
        }
      }

    } catch (error) {
      console.error("Error loading draft:", error);
    }
  };

  const fetchDeliveryOtp = async (caseID: number) => {
    try {
      const res = await apiAxios.get(
        `${API_BASE_URL}/Dentist/GetClinicOtp?caseId=${caseID}`
      );

      if (res.data?.isSuccess) {
        setDeliveryOtp(res.data.singleData); (
          console.log(res, "OTPPPPPPPPPPPPPPPPPPPPP")
        )
      } else {
        toast.error("OTP not found");
      }
    } catch (err) {
      console.error(err);
    }
  };
  const fetchOrdersByPatient = async (patientId: number) => {
    try {
      setLoading(true);

      const token = getAuthToken();

      const res = await apiAxios.post(
        `${API_BASE_URL}/Dentist/GetAllPatientCasesDashboard`,
        { UserID: patientId },
        {
          headers: {
            AuthorizationData: token,
            "Content-Type": "application/json",
          },
        }
      );
      setPatientOrders(res.data.singleData || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  const fetchCancellationReasons = async () => {
    try {
      const res = await apiAxios.get(
        `${API_BASE_URL}/CancellationReason/GetAll`
      );

      if (
        res.data?.isSuccess &&
        Array.isArray(res.data.singleData)
      ) {
        setCancellationReasons(
          res.data.singleData.filter((x: any) => x.isActive)
        );
      }
    } catch (error) {
      console.error("Error fetching cancellation reasons", error);
    }
  };

  useEffect(() => {
    fetchCancellationReasons();
  }, []);


  useEffect(() => {
    const loadClinic = () => {
      const clinicId = sessionStorage.getItem("selectedClinicId");

      if (clinicId) {
        setSelectedClinicId(Number(clinicId));
      }
    };

    // ✅ load automatically on first login/refresh
    loadClinic();
    getConversations();

    // ✅ listen when clinic changes
    window.addEventListener("clinicChanged", loadClinic);

    return () => {
      window.removeEventListener("clinicChanged", loadClinic);
    };

  }, []);


  const handleReuploadScan = (): void => {
    console.log("Before click, scrollY:", window.scrollY);

    if (!selectedOrder?.caseID) {
      toast.error("Case ID not found");
      return;
    }

    const caseId = selectedOrder?.isClubbed
      ? selectedOrders[0]?.caseID
      : selectedOrder?.caseID;

    setReuploadCaseId(caseId ?? null);
    setViewMode("addScan");

    setTimeout(() => {
      console.log("After click, scrollY:", window.scrollY);
    }, 300);
  };
  const [showUnderReviewToast, setShowUnderReviewToast] = useState(false);


  const handleContinue = (): void => {
    if (selectedOrder?.isClubbed) {
      selectedOrders.forEach(o =>
        updateOrderTagLocally(o.caseID, "Under Review")
      );
    } else if (selectedOrder?.caseID) {
      updateOrderTagLocally(selectedOrder.caseID, "Under Review");
    }
    setShowUnderReviewToast(true);
    setViewMode("underReview"); // ✅ clean switch
    // setShowUnderReviewToast(true); // ✅ FROM UPLOAD FLOW
    // setShowCaseDetails(true);
    // setShowReuploadDetails(false);
    // setShowAddscan(false);
    // setShowUnderReview(true);
  };

  const fetchPatients = async (clinicId?: number | null) => {
    const selectedClinic = JSON.parse(sessionStorage.getItem("selectedClinic") || "{}");
    setLoading(true);
    try {
      const token = sessionStorage.getItem("token") || "";
      const res = await apiAxios.post(
        `${API_BASE_URL}/Patient/GetAllPatientDashBoard`,
        selectedClinic.clinicID ? { clinicId: selectedClinic.clinicID } : {},
        {
          headers: {
            AuthorizationData: token,
            "Content-Type": "application/json",
          },
        }
      );


      const data = await res.data;
      setPatient(data.reverse());
    } catch (error) {
      console.error("Error fetching patients:", error);
    } finally {
      setLoading(false);
    }
  };


  const updateOrderTagLocally = (caseID: number, newTag: string) => {
    setOrders(prev =>
      prev.map(order =>
        order.caseID === caseID
          ? { ...order, dentistTag: newTag }
          : order
      )
    );
  };


  // const fetchOrders = async (clinicId?: number | null) => {
  //   const selectedClinic = JSON.parse(sessionStorage.getItem("selectedClinic") || "{}");
  //   try {
  //     setLoading(true);
  //     const token = getAuthToken();
  //     const res = await apiAxios.post(
  //       `${API_BASE_URL}/Dentist/GetAllCasesDashBoard`,
  //       selectedClinic.clinicID ? { clinicId: selectedClinic.clinicID } : {},
  //       {
  //         headers: {
  //           AuthorizationData: token,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     const allOrders = res.data.singleData || [];
  //     setOrders(allOrders);
  //   } catch (err) {
  //     console.error(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  const fetchOrders = async (clinicId?: number | null) => {
    try {
      setLoading(true);

      // 🚫 No clinic selected → don't load all data
      if (clinicId === null || clinicId === undefined) {
        setOrders([]);
        return;
      }

      const token = getAuthToken();

      const res = await apiAxios.post(
        `${API_BASE_URL}/Dentist/GetAllCasesDashBoard`,
        { clinicId: clinicId }, // ✅ always send selected clinic
        {
          headers: {
            AuthorizationData: token,
            "Content-Type": "application/json",
          },
        }
      );
      // console.log(res.data.singleData,"order check");
      // setOrders(res.data.singleData || []);

      const data = res.data.singleData || [];

      console.log(data, "order check");

      // normal orders
      const normalOrders = data.filter((x: any) => !x.isClubbed);

      // grouped clubbed orders
      const groupedClubbed = Object.values(
        data
          .filter((x: any) => x.isClubbed)
          .reduce((acc: any, item: any) => {

            if (!acc[item.clubGroupId]) {
              acc[item.clubGroupId] = {
                ...item,
                orders: []
              };
            }

            acc[item.clubGroupId].orders.push(item);

            return acc;

          }, {})
      );

      // setOrders([
      //   ...normalOrders,
      //   ...(groupedClubbed as any)
      // ]);
      const finalOrders = [
        ...normalOrders,
        ...(groupedClubbed as any)
      ].sort((a: any, b: any) => b.caseID - a.caseID);

      setOrders(finalOrders);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  // useEffect(() => {
  //   fetchOrders(selectedClinicId);
  //   fetchPatients(selectedClinicId);
  // }, [selectedClinicId]);
  useEffect(() => {
    if (selectedClinicId) {
      fetchOrders(selectedClinicId);
      fetchPatients(selectedClinicId);
    } else {
      setOrders([]);
      setPatient([]);
    }
  }, [selectedClinicId]);
  const handleToothClick = (toothNumber: number, event?: React.MouseEvent) => {
    setSelectedTeeth((prev) => {
      let updated = [...prev];
      const exists = prev.find((t) => t.toothNumber === toothNumber);

      if (event?.shiftKey && lastClickedTooth) {
        const start = Math.min(lastClickedTooth, toothNumber);
        const end = Math.max(lastClickedTooth, toothNumber);
        const range = Array.from({ length: end - start + 1 }, (_, i) => start + i);
        range.forEach((num) => {
          if (!updated.find((t: any) => t.toothNumber === num)) {
            updated.push({
              toothNumber: num,
              materialId: null,
              shadeId: null,
              hasBridge: false,
            });
          }
        });


        return updated;
      }

      if (exists) return updated.filter((t) => t.toothNumber !== toothNumber);

      updated.push({ toothNumber, materialId: null, shadeId: null, hasBridge: false });
      return updated;
    });

    setLastClickedTooth(toothNumber);
  };
  const toggleBridge = (group: number[]) => {
    setSelectedTeeth((prev) => {
      let updated = [...prev];
      const [a, b] = group;
      const teethToBridge = new Set < number > ([a, b]);
      let newBridgeId = 1;
      const existingIds = new Set(prev.map((t) => t.bridgeGroupId).filter(Boolean));
      while (existingIds.has(newBridgeId)) newBridgeId++;

      updated = updated.map((t) =>
        teethToBridge.has(t.toothNumber)
          ? { ...t, hasBridge: !t.hasBridge, bridgeGroupId: newBridgeId }
          : t
      );

      return updated;
    });
  };

  useEffect(() => {
    if (selectedTeeth.length > 0) {
      sessionStorage.setItem("orderStarted", "true");
    } else {
      sessionStorage.removeItem("orderStarted");
    }
  }, [selectedTeeth]);
  const handleCreateNewCase = () => {
    //setShowCaseDetails(true);
    sessionStorage.removeItem("fileUrl");
    sessionStorage.removeItem("caseNotes");
    sessionStorage.removeItem("serviceType");
    sessionStorage.removeItem("slotDate");
    sessionStorage.removeItem("slotTime");
    setActiveTab('orders');
    setViewMode("caseDetails");
  };

  const openOrder = async (order: OrderType) => {
    console.log("Clicked Order", order);

    setSelectedOrder(order);

    if (order.isClubbed && order.orders?.length) {
      setSelectedOrders(order.orders);
      console.log("Clubbed Orders", order.orders);
      console.log(
        "Case IDs",
        order.orders.map(x => x.caseID)
      );
    } else {

      setSelectedOrders([order]);
    }
    const outForDeliveryOrder =
      order.dentistTag === "Out for Delivery"
        ? order
        : order.orders?.find(x => x.dentistTag === "Out for Delivery");

    if (outForDeliveryOrder) {
      await fetchDeliveryOtp(outForDeliveryOrder.caseID);
    }
    if (
      viewMode === "underReview" &&
      selectedOrder?.caseID === order.caseID
    ) {
      return;
    }

    setSelectedOrder(order);

    // ⭐ OTP fetch when Out for Delivery
    // if (order.dentistTag === "Out for Delivery") {
    //   await fetchDeliveryOtp(order.caseID);
    // }



    if (order.dentistTag === "Re-upload Scan") {
      setViewMode("reuploadDetails");
    } else if (order.dentistTag === "Scan Pending") {
      // Slot Booking order: scan upload option on scheduled date
      setViewMode("slotScan");
    } else {
      setShowUnderReviewToast(false);
      setViewMode("underReview");
    }
  };

  const handleBackToDashboard = () => {
    setViewMode("dashboard");
    setSelectedTeeth([]);
    setSelectedPatient(null);
    setPriceSummary(null);
    sessionStorage.removeItem("orderStarted");
    localStorage.removeItem("orderSummary");
    sessionStorage.removeItem("caseNotes");
    sessionStorage.removeItem("fileUrl");
    fetchOrders(selectedClinicId);
    fetchPatients(selectedClinicId);

    // ⭐ remove draftId from URL
    navigate("/dentist/dashboard", { replace: true });

  };

  const fetchWarranty = async (caseId: number) => {
    try {
      const res = await apiAxios.get(`${API_BASE_URL}/DeliveryPartner/GetWarrantyByCase?caseId=${caseId}`);
      if (res.data?.isSuccess) {
        return res.data.data; // multiple warranty cards possible
      }
    } catch {
      toast.error("Failed to fetch warranty");
    }
  };
  const chunkArray = (arr: any[], size: number) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };
  const downloadWarrantyPDF = async (row: any) => {

    const warranties = await fetchWarranty(row.caseID);

    if (!warranties || warranties.length === 0) {
      toast.error("No warranty found");
      return;
    }
    const pages = chunkArray(warranties, 3); // 🔥 3 cards per page

    const pdf = new jsPDF("p", "mm", "a4");

    for (let i = 0; i < pages.length; i++) {

      const container = document.createElement("div");
      container.style.position = "fixed";
      container.style.top = "-9999px";   // 👈 push outside screen
      container.style.left = "-9999px";
      container.style.width = "800px";
      container.style.padding = "20px";
      container.style.background = "#fff";

      document.body.appendChild(container);

      const { createRoot } = await import("react-dom/client");
      const root = createRoot(container);

      // 🔥 Render only current page cards
      root.render(
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {pages[i].map((w: any, index: number) => (
            <WarrantyCard
              key={index}
              data={{
                patientName: w.patientName,
                mobile: w.mobile,
                treatment: w.treatmentType,
                toothNumber: w.toothNumber,
                material: w.material,
                warrantyMonths: w.warrantyPeriodMonths,
                validTill: new Date(w.warrantyEndDate).toLocaleDateString(),
                warrantyNumber: w.warrantyNumber,
                dentistName: w.name
              }}
            />
          ))}
        </div>
      );

      // 🔥 wait for render
      await new Promise(res => setTimeout(res, 1000));

      const canvas = await html2canvas(container, {
        scale: 3,
        useCORS: true
      });

      const imgData = canvas.toDataURL("image/png");

      if (i > 0) pdf.addPage(); // 🔥 next page

      pdf.addImage(imgData, "PNG", 10, 10, 190, 0);

      root.unmount();
      document.body.removeChild(container);
    }

    pdf.save(`Warranty-${row.caseID}.pdf`);


  };

const handleCancelRequest = async () => {
  try {
    if (!selectedOrder?.caseID) {
      toast.error("Case not found");
      return;
    }

    if (!cancelReason.trim()) {
      toast.error("Please enter cancellation reason");
      return;
    }
    const clinicId = Number(sessionStorage.getItem("selectedClinicId"));

    setCancelLoading(true);

    const token = getAuthToken();

    const payload = {
      caseID: selectedOrder?.isClubbed
        ? selectedCancelCaseId
        : selectedOrder?.caseID,
      cancellationReason: cancelReason,
      remarks: cancelRemarks,
      clinicID: clinicId
    };

    const res = await apiAxios.post(
      `${API_BASE_URL}/Dentist/cancel-request`,
      payload,
      {
        headers: {
          AuthorizationData: token,
          "Content-Type": "application/json"
        }
      }
    );

    if (res.data?.isSuccess) {
      toast.success(res.data.message);

      setOrders(prev =>
        prev.map(order =>
          order.caseID === selectedOrder.caseID
            ? {
              ...order,
              dentistTag: "Cancellation Under Review"
            }
            : order
        )
      );

      setShowCancelModal(false);
      setCancelReason("");
      setCancelRemarks("");

      fetchOrders(selectedClinicId);
    } else {
      toast.error(res.data?.message || "Cancellation failed");
    }
  } catch (err) {
    console.error(err);
    toast.error(
      err?.response?.data?.message ||
      "Cancellation failed"
    );
  } finally {
    setShowCancelModal(false);
    setCancelReason("");
    setCancelRemarks("");
    setCancelLoading(false);
    
    if (selectedClinicId) {
      fetchOrders(selectedClinicId);
    }
  }
};


//   const handleCancelRequest = async () => {
//     try {
//       if (!selectedOrder?.caseID) {
//         toast.error("Case not found");
//         return;
//       }

//       if (!cancelReason.trim()) {
//         toast.error("Please enter cancellation reason");
//         return;
//       }
//       const clinicId = Number(sessionStorage.getItem("selectedClinicId"));

//       setCancelLoading(true);

//       const token = getAuthToken();

//       const payload = {
//         caseID: selectedOrder?.isClubbed
//           ? selectedCancelCaseId
//           : selectedOrder?.caseID,
//         cancellationReason: cancelReason,
//         remarks: cancelRemarks,
//         clinicID: clinicId
//       };

//       const res = await apiAxios.post(
//         `${API_BASE_URL}/Dentist/cancel-request`,
//         payload,
//         {
//           headers: {
//             AuthorizationData: token,
//             "Content-Type": "application/json"
//           }
//         }
//       );

//       if (res.data?.isSuccess) {
//         toast.success(res.data.message);

//         setOrders(prev =>
//           prev.map(order =>
//             order.caseID === selectedOrder.caseID
//               ? {
//                 ...order,
//                dentistTag: "Cancellation Under Review"
//               }
//               : order
//           )
//         );

//         setShowCancelModal(false);
//         setCancelReason("");
//         setCancelRemarks("");

//         fetchOrders(selectedClinicId);
//       } else {
//   toast.error(res.data?.message || "Cancellation failed");

//   // Close cancellation popup
//   setShowCancelModal(false);

//   // Clear cancellation form
//   setCancelReason("");
//   setCancelRemarks("");

//   // Refresh dashboard
//   await fetchOrders(selectedClinicId);
// }
//     } catch (err: any) {
//       console.error(err);

//       toast.error(
//         err?.response?.data?.message ||
//         "Cancellation failed"
//       );
//     } finally {
//       setCancelLoading(false);
//     }
//   };
  const openFreshChat = async () => {
    setSelectedConversation(null);
    setMessages([]);
    setMessage("");
    setSelectedFile(null);
    setPreviewUrl("");
    setExpandedMessages([]);

    await getConversations();

    setShowChatPopup(true);
  };

  return (
    <div className="row" style={{ alignItems: "stretch", overflowX: "hidden" }}>
      <div className="row g-0 w-100 m-0">
        {viewMode !== "caseDetails" && (
          <div className="col-md-6 col-lg-5 col-12">
            <div className="left-section-maindiv">
              <div className="patintorder" style={{ display: "flex" }}>
                <div
                  onClick={() => setActiveTab("orders")}
                  style={{
                    flex: 1,
                    padding: "5px 0",
                    textAlign: "center",
                    cursor: "pointer",
                    fontSize: "16px",

                    color: activeTab === "orders" ? "#3D8BFD" : "#888",
                    borderBottom:
                      activeTab === "orders"
                        ? "1.5px solid #3D8BFD"
                        : "1.5px solid transparent",
                  }}
                >
                  Orders
                </div>

                <div
                  onClick={() => {
                    setActiveTab("patients");

                    setSelectedTeeth([]);
                    setLastClickedTooth(null);
                    setSelectedOrder(null);
                    setViewMode("dashboard");
                    setDeliveryOtp(null);
                  }}
                  style={{
                    flex: 1,
                    marginLeft: "30px",
                    padding: "5px 0",
                    textAlign: "center",
                    cursor: "pointer",
                    color: activeTab === "patients" ? "#3D8BFD" : "#888",
                    borderBottom:
                      activeTab === "patients"
                        ? "1.5px solid #3D8BFD"
                        : "1.5px solid transparent",
                  }}
                >
                  Patients
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  maxWidth: "100%",
                  borderRadius: "12px",
                  marginTop: "10px",
                  background: "transparent",
                }}
              >
                <div className="left-content-section-list" style={{ overflowX: "hidden" }}>

                  {activeTab === "orders" && (
                    <>
                      {orders.length === 0 ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            textAlign: "center",
                            color: "#888",
                            fontSize: "16px"
                          }}
                        >
                          No Active Orders
                        </div>
                      ) : (
                        orders.map((order) => (

                          <ul
                            className="customflexcolumdentishdashboard"
                            key={order.caseID}
                            style={{
                              padding: "6px 12px",
                              marginBottom: "8px",
                              borderRadius: "5px",
                              background: "#f9f9f9",
                            }}
                            onClick={() =>

                              openOrder(order)}
                          >
                            <li
                              style={{ fontSize: "14px", color: "#303030" }}
                            >
                              {order.isClubbed ? (
                                order.orders?.map((o: any) => (
                                  <div key={o.caseID}>
                                    {o.orderID}
                                  </div>
                                ))
                              ) : (
                                order.orderID
                              )}
                            </li>
                            <li
                              className="patient-name"
                              title={order.patientName}
                            >
                              {order.patientName}
                            </li>


                            <li>
                              {order.isClubbed ? (
                                order.orders?.map((o: any) => (
                                  <div
                                    key={o.caseID}
                                    style={{
                                      marginBottom: "6px",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "flex-end",
                                    }}
                                  >
                                    {o.delayTime &&
                                      o.delayTime !== "On Time" &&
                                      o.delayTime !== "N/A" && (
                                        <div
                                          style={{
                                            fontSize: "12px",
                                            color: "#E24B4A",
                                            whiteSpace: "nowrap",
                                            borderBottom: "1px solid #cccccc45",
                                            marginBottom: "3px",
                                            paddingBottom: "2px",
                                          }}
                                        >
                                          ⏱ {o.delayTime} late
                                        </div>
                                      )}

                                    <div
                                      className={`status-pill-active ${STATUS_CONFIG[o.dentistTag]?.className || ""
                                        }`}
                                      title={o.dentistTag}
                                      style={{
                                        backgroundColor: STATUS_CONFIG[o.dentistTag]?.bg,
                                        padding: "2px 7px",
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        display: "inline-flex",
                                        alignItems: "center",
                                        maxWidth: "160px",
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      <i
                                        className="bi bi-clock-fill clock-fill-color"
                                        style={{ marginRight: "6px", flexShrink: 0 }}
                                      />
                                      <span
                                        style={{
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {o.dentistTag}
                                      </span>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <>
                                  <div className="delay-time-and-button">
                                    {order.delayTime &&
                                      order.delayTime !== "On Time" &&
                                      order.delayTime !== "N/A" && (
                                        <div
                                          style={{
                                            fontSize: "12px",
                                            color: "#E24B4A",
                                            whiteSpace: "nowrap",
                                            borderBottom: "1px solid #cccccc45",
                                            marginBottom: "3px",
                                            paddingBottom: "2px",
                                          }}
                                        >
                                          ⏱ {order.delayTime} late
                                        </div>
                                      )}
                                  </div>

                                  <div
                                    className={`status-pill-active ${STATUS_CONFIG[order.dentistTag]?.className || ""
                                      }`}
                                    title={order.dentistTag}
                                    style={{
                                      backgroundColor: STATUS_CONFIG[order.dentistTag]?.bg,
                                      padding: "2px 7px",
                                      fontSize: "12px",
                                      fontWeight: 500,
                                    }}
                                  >
                                    <i className="bi bi-clock-fill clock-fill-color me-1" />
                                    <span>{order.dentistTag}</span>
                                  </div>
                                </>
                              )}
                            </li>
                          </ul>
                        ))
                      )}
                    </>
                  )}

                  {activeTab === "patients" &&
                    Patient.map((p) => (

                      <div
                        className="customflexcolumdentishdashboard"
                        key={p.patientID ?? `patient-${p.patientID}`}
                        onClick={() => {
                          setSelectedPatientRow(p.patientID);
                          fetchOrdersByPatient(p.patientID);
                        }}
                        // style={{
                        //   padding: "12px 12px",
                        //   marginBottom: "14px",
                        //   borderRadius: "5px",
                        //   display: "flex",
                        //   justifyContent: "space-between",
                        //   alignItems: "center",
                        //   cursor: "pointer",
                        //   margin: "10px",
                        // }}
                        style={{
                          padding: "12px",
                          marginBottom: "10px",
                          borderRadius: "5px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          cursor: "pointer",

                          // ⭐ highlight logic
                          background:
                            selectedPatientRow === p.patientID ? "#e7f1ff" : "#f9f9f9",
                          border:
                            selectedPatientRow === p.patientID
                              ? "1px solid #3D8BFD"
                              : "1px solid transparent",
                        }}
                      >
                        <div style={{ fontSize: "15px", fontWeight: 500 }}>
                          {p.patientName}
                        </div>
                        <div style={{ fontSize: "14px", color: "#666" }}>
                          Age : {p.age}
                        </div>
                        {/* ✅ STATUS BADGE */}
                        {p.dentistTag && (
                          <div
                            className={`status-pill-active ${STATUS_CONFIG[p.dentistTag]?.className || ""
                              }`}
                            style={{
                              display: "inline-block",
                              marginTop: "6px",
                              padding: "4px 8px",
                              borderRadius: "20px",
                              fontSize: "12px",
                              fontWeight: 500,
                              float: "right",
                              backgroundColor: STATUS_CONFIG[p.dentistTag]?.bg || "#eee",
                              color:
                                p.dentistTag === "Under Review" ? "#000" : "#fff",
                            }}
                          >
                            {p.dentistTag}
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        )}
        <>
          {viewMode !== "caseDetails" && (
            <>
              <div className="col-lg-1"></div>
              <div className="col-md-6 col-12 col-lg-5 right-teeth-svg-section ">
                <div className="right-section-maindiv" style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                  {viewMode === "dashboard" && (
                    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <DentalChart key={"DentalChart-" + selectedOrder?.caseID}
                          selectedTeeth={selectedTeeth.map((t) => ({
                            toothNumber: t.toothNumber,
                            hasBridge: t.hasBridge,
                            bridgeGroupId: t.bridgeGroupId,
                          }))}
                          handleToothClick={handleToothClick}
                          toggleBridge={toggleBridge}
                        />
                      </div>

                      <div style={{ textAlign: "center", paddingBottom: "16px" }}>
                        <div className="create-order-wrapper-btn-section">
                          {selectedTeeth.length === 0 ? (
                            <button
                              className="selectteethtext"
                              onClick={handleCreateNewCase}
                            >
                              Select teeth to create new order
                            </button>
                          ) : (
                            <div className="order-actions-btn-section">
                              <div className="selected-pill selected-teeth-btn">
                                <div
                                  className="close-icon-of-teeth"
                                  onClick={() => setSelectedTeeth([])}
                                >
                                  ✕
                                </div>
                                <div className="selected-teeth-part">
                                  {selectedTeeth.length} Selected
                                </div>
                              </div>

                              <button
                                className="create-order-btn"
                                onClick={handleCreateNewCase}
                              >
                                Create New Order
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {/* ✅ BOTTOM: Patient Orders Panel */}
                  {activeTab === "patients" && selectedPatientRow && (
                    <div
                      className="order-left-section-dentist"
                      style={{
                        marginTop: "20px",
                        background: "#f8f9fb",
                        borderRadius: "10px",
                        padding: "15px",
                        height: "250px",
                        overflowY: "auto",
                        width: "100%"
                      }}
                    >
                      <div
                        style={{
                          fontWeight: 600,
                          marginBottom: "10px",
                          borderBottom: "2px solid #3D8BFD",
                          display: "inline-block",
                          paddingBottom: "4px"
                        }}
                      >
                        Orders
                      </div>

                      {patientOrders.length === 0 ? (
                        <div style={{ color: "#888", marginTop: "10px" }}>
                          No Orders Found
                        </div>
                      ) : (
                        patientOrders.map((order) => (
                          <div
                            key={order.caseID}
                            onClick={() => {
                              if (order.isClubbed && order.orders && order.orders.length > 0) {
                                openOrder(order.orders[0]);
                              } else {
                                openOrder(order);
                              }
                            }}
                            style={{
                              padding: "10px",
                              borderRadius: "6px",
                              marginBottom: "8px",
                              background: "#fff",
                              cursor: "pointer",
                              border: "1px solid #eee"
                            }}
                          >
                            <div className="status-order-badges">
                              <div className="status-badge-section">
                                <div style={{ fontWeight: 500 }}>{order.orderID}</div>

                                <div style={{ fontSize: "13px", color: "#666" }}>
                                  {order.patientName}
                                </div>
                              </div>

                              {/* ✅ STATUS BADGE */}
                              {order.dentistTag && (
                                <div

                                  className={`status-pill-active ${STATUS_CONFIG[order.dentistTag]?.className || ""
                                    }`}
                                  style={{
                                    display: "inline-block",
                                    height: "25px",
                                    marginTop: "6px",
                                    padding: "4px 8px",
                                    borderRadius: "20px",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    backgroundColor:
                                      STATUS_CONFIG[order.dentistTag]?.bg || "#eee",
                                    color:
                                      order.dentistTag === "Under Review"
                                        ? "#000"
                                        : "red",
                                  }}
                                >
                                  {order.dentistTag}
                                </div>
                              )}

                              {/* ✅ WARRANTY BUTTON (ONLY IF DELIVERED) */}
                              {order.dentistTag === "Delivered" && (
                                <div style={{ marginTop: "8px" }}>
                                  <button
                                    onClick={async (e) => {
                                      e.stopPropagation();

                                      const result = await Swal.fire({
                                        title: "Download Warranty?",
                                        text: "Do you want to download the warranty PDF?",
                                        icon: "question",
                                        showCancelButton: true,
                                        confirmButtonText: "Yes, Download",
                                        cancelButtonText: "No",
                                        confirmButtonColor: "#3D8BFD",
                                      });

                                      if (result.isConfirmed) {
                                        toast.info("Warranty download in progress...");
                                        downloadWarrantyPDF(order);
                                      }
                                    }}
                                    style={{
                                      padding: "6px 10px",
                                      fontSize: "12px",
                                      height: "25px",
                                      borderRadius: "5px",
                                      border: "none",
                                      background: "#3D8BFD",
                                      color: "#fff",
                                      cursor: "pointer"
                                    }}
                                  >
                                    ⬇ Download Warranty
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  )}

                  {viewMode === "reuploadDetails" && (
                    <ReuploadScan key={selectedOrder?.id}
                      order={selectedOrder}
                      onReuploadClick={handleReuploadScan}
                      onCancelClick={() => setShowCancelModal(true)}
                      onClose={() => {
                        setViewMode("dashboard");
                      }}

                    />
                  )}
                  {viewMode === "slotScan" && selectedOrder && (
                    <SlotScanPending key={selectedOrder?.id}
                      order={selectedOrder}
                      onUploadClick={handleReuploadScan}
                      onCancelClick={() => setShowCancelModal(true)}
                      onClose={() => {
                        setViewMode("dashboard");
                      }}
                    />
                  )}
                  {viewMode === "addScan" && reuploadCaseId && (
                    <div ref={addScanSectionRef}>
                      <ReuploadAddScan
                        key={"ReuploadAddScan-" + reuploadCaseId}
                        caseID={reuploadCaseId}
                        currentOrderState={selectedOrder?.currentOrderState}
                        onContinueClick={handleContinue}
                        onBack={() => {
                          setViewMode("dashboard");
                        }}
                      />
                    </div>
                  )}
                  {(selectedOrder?.dentistTag === "Out for Delivery" ||
                    selectedOrder?.orders?.some(x => x.dentistTag === "Out for Delivery")) &&
                    deliveryOtp && (
                      <div
                        style={{
                          marginTop: "15px",
                          padding: "12px",
                          background: "#f1f7ff",
                          borderRadius: "8px",
                          textAlign: "center",
                          fontWeight: "600",
                          fontSize: "18px"
                        }}
                      >
                        Delivery OTP : {deliveryOtp}
                      </div>
                    )}
                  {viewMode === "underReview" && selectedOrders.length > 0 && (
                    <ReuploadAddScanUnderreview
                      orders={selectedOrders}
                      showSuccessToast={showUnderReviewToast}
                      onCancelClick={(caseIds) => {
                        console.log("Selected CaseIds:", caseIds);

                        setSelectedCancelCaseId(caseIds[0]); // only one because you're using radio
                        setShowCancelModal(true);
                      }}
                      onClose={() => {
                        setSelectedTeeth([]);
                        localStorage.removeItem("orderSummary");
                        setViewMode("dashboard");
                        setDeliveryOtp(null);
                        fetchOrders(selectedClinicId);
                      }}
                    />
                  )}

                </div>
              </div>
            </>
          )}

          {viewMode === "caseDetails" && (
            <div className="col-md-12">
              <CaseDetails key={"CaseDetails-" + draftId}
                // data={selectedTeeth}
                // onChange={setSelectedTeeth}
                // onBack={handleBackToDashboard}
                files={files}     // ⭐ pass STL files
                data={selectedTeeth}
                patient={selectedPatient}
                priceSummary={priceSummary}
                draftId={draftId}   // ⭐ ADD THIS
                draftSlot={draftSlot}
                onChange={setSelectedTeeth}
                onBack={handleBackToDashboard}
              />
            </div>
          )}

          {/* CANCEL ORDER MODAL */}
          {showCancelModal && (
            <div
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999
              }}
            >
              <div
                style={{
                  width: "420px",
                  background: "#fff",
                  borderRadius: "10px",
                  padding: "20px"
                }}
              >
                <div className="d-flex justify-content-between ">

                  <div
                    style={{
                      fontSize: "18px",
                      fontWeight: 600,
                      marginBottom: "15px"
                    }}
                  >
                    Cancel Order
                  </div>

                 <button
  type="button"
  className="btn-close custom-close-btn"
  aria-label="Close"
  onClick={() => {
    setShowCancelModal(false);
    setCancelReason("");
    setCancelRemarks("");
  }}
>
  <i className="bi bi-x customcross"></i>
</button>
                </div>

                <div style={{ marginBottom: "12px" }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "6px",
                      fontWeight: 500
                    }}
                  >
                    Cancellation Reason
                  </label>

                  <select
                    value={cancelReason}
                    onChange={(e) => setCancelReason(e.target.value)}
                    style={{
                      width: "100%",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      padding: "10px"
                    }}
                  >
                    <option value="">Select Reason</option>

                    {cancellationReasons.map((reason: any) => (
                      <option
                        key={reason.cancellationReasonID}
                        value={reason.cancellationReasonName}
                      >
                        {reason.cancellationReasonName}
                      </option>
                    ))}
                  </select>
                </div>

                <div style={{ marginBottom: "12px" }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "6px",
                      fontWeight: 500
                    }}
                  >
                    Remarks
                  </label>

                  <textarea
                    value={cancelRemarks}
                    onChange={(e) => setCancelRemarks(e.target.value)}
                    rows={3}
                    style={{
                      width: "100%",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      padding: "10px"
                    }}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px"
                  }}
                >
                  <button
                    onClick={handleCancelRequest}
                    disabled={cancelLoading}
                    className="btn-primary  btn"
                  >
                    {cancelLoading ? "Submitting..." : "Submit"}
                  </button>
                  <button
                    onClick={() => {
                      setShowCancelModal(false);
                      setCancelReason("");
                      setCancelRemarks("");
                    }}
                    className="btn-secondary mx-1 btn"
                  >
                    Close
                  </button>


                </div>
              </div>
            </div>
          )}
        </>

        {/* ✅ Floating Chat Button - always visible, independent of modal */}
        <button
          className="btn btn-primary rounded-circle shadow chat-fab-btn"
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            width: "56px",
            height: "56px",
            zIndex: 1050,
          }}
          // onClick={async () => {
          //   setShowChatPopup(!showChatPopup);

          //   await getConversations();
          // }}
          onClick={() => {
            if (showChatPopup) {
              setShowChatPopup(false);
            } else {
              openFreshChat();
            }
          }}
        >
          <i className="bi bi-chat-dots-fill fs-4"></i>
          {conversationCount > 0 && (
            <span
              className="badge bg-danger rounded-pill chat-fab-badge"
            >
              {conversationCount}
            </span>
          )}
        </button>

        {showChatPopup && (
          <div
            className="card shadow chat-widget-container"
            style={{
              position: "fixed",
              bottom: "90px",
              right: "20px",
              width: "800px",
              maxWidth: "95vw",
              height: "480px",
              maxHeight: "80vh",
              zIndex: 1050,
              borderRadius: "15px",
              overflow: "hidden",
            }}
          >
            <div className="row g-0  flex-column flex-md-row">

              {/* Conversation List */}
              <div
                className="col-12 col-md-4 border-end conversation-list-col d-flex flex-column"
              >
                <div className="padding-sectionofconver border-bottom">
                  <h5 className="mb-0">Conversations</h5>
                </div>

                <div className="conversation-scroll">
                  {conversations.map((chat) => (
                    <div
                      key={chat.ticketId}
                      className={`p-3 border-bottom ${selectedConversation?.ticketId === chat.ticketId ? "bg-light" : ""
                        }`}
                      style={{ cursor: "pointer" }}
                      onClick={() => openConversation(chat)}
                    >
                      <div className="d-flex justify-content-between">
                        <strong>Order Query - {chat.orderId}</strong>
                        {chat.unreadCount > 0 && (
                          <span className="badge bg-danger">{chat.unreadCount}</span>
                        )}
                      </div>
                      <small
                        className="text-muted d-block"
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: "100%",
                        }}
                      >
                        {chat.lastMessage}
                      </small>
                    </div>
                  ))}
                </div>
              </div>
              {/* Chat Section */}
              <div className="col-12 col-md-8 d-flex flex-column chat-section-col">
                {/* Header */}
                <div className="p-3 border-bottom bg-white top-sectionbg-white" style={{ flexShrink: 0 }}>
                  <h6 className="mb-0">
                    {selectedConversation
                      ? `Order Query - ${selectedConversation.orderId}`
                      : "Select Conversation"}
                  </h6>
                </div>

                {/* Messages */}
                <div
                  className="p-3 conversation-scroll body-section-part"
                  style={{ flex: 1, overflowY: "auto" }}
                >
                  {loadingMessages ? (
                    <div className="text-center mt-5">Loading...</div>
                  ) : (
                    messages.map((msg) => {
                      const isExpanded = expandedMessages.includes(msg.id);
                      const shouldShowToggle = (msg.message?.length ?? 0) > 150;

                      return (
                        <div
                          key={msg.id}
                          className={`d-flex mb-3 ${msg.senderType === "Dentist" ? "justify-content-end" : "justify-content-start"
                            }`}
                        >
                          <div
                            className={`p-2 rounded ${msg.senderType === "Dentist"
                              ? "bg-primary text-white blue-section-end"
                              : "bg-white border white-section-chat-start"
                              }`}
                            style={{ maxWidth: "80%", wordBreak: "break-word" }}
                          >
                            <div>
                              {shouldShowToggle ? (
                                <>
                                  {isExpanded ? msg.message : `${msg.message?.substring(0, 150)}...`}
                                  <div>
                                    <button
                                      type="button"
                                      className="btn btn-link p-0"
                                      onClick={() => toggleMessage(msg.id)}
                                    >
                                      {isExpanded ? "Show Less" : "Show More"}
                                    </button>
                                  </div>
                                </>
                              ) : (
                                msg.message
                              )}
                            </div>

                            {msg.filePath && (
                              <div className="mt-2">
                                <a href={`${API_PATH}/uploads/chat/${msg.filePath}`} target="_blank" rel="noreferrer">
                                  Attachment
                                </a>
                              </div>
                            )}

                            <div className="mt-1">
                              <small>
                                {msg.createdDate ? new Date(msg.createdDate).toLocaleString("en-GB") : ""}
                              </small>
                            </div>
                          </div>
                        </div>
                      );

                    })

                  )}
                  <div ref={messagesEndRef} />
                </div>


                {/* Footer */}
                <div className="p-3 border-top footer-section-part-top" style={{ flexShrink: 0 }}>
                  {selectedFile && (
                    <div className="mb-2 border rounded p-2 bg-light">
                      <div className="d-flex justify-content-between align-items-start">
                        {previewUrl ? (
                          <img
                            src={previewUrl}
                            alt="Preview"
                            style={{ maxWidth: "120px", maxHeight: "100px", borderRadius: "8px" }}
                          />
                        ) : (
                          <div>📎 {selectedFile.name}</div>
                        )}
                        <button
                          className="btn btn-sm btn-danger ms-3"
                          type="button"
                          onClick={() => {
                            setSelectedFile(null);
                            setPreviewUrl("");
                          }}
                        >
                          ×
                        </button>
                      </div>
                    </div>
                  )}
                  <div className="d-flex gap-2 flex-nowrap">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Type a message..."
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") sendMessage();
                      }}
                    />

                    <input
                      type="file"
                      hidden
                      id="designerFile"
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file) {
                          setSelectedFile(file);
                          if (file.type.startsWith("image/")) {
                            setPreviewUrl(URL.createObjectURL(file));
                          } else {
                            setPreviewUrl("");
                          }
                        }
                      }}
                    />

                    <label htmlFor="designerFile" className="btn btn-outline-secondary">
                      <i className="bi bi-paperclip"></i>
                    </label>

                    <button className="btn btn-primary" onClick={sendMessage}>
                      <i className="bi bi-send-fill"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>

  );
};

export default Dashboard;